import React from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import Currency from "@mapmycustomers/shared/types/Currency";

import OverlayView from "@app/component/map/FeaturedMap/essentials/OverlayView";
import useMap from "@app/component/map/FeaturedMap/utils/useMap";
import { getCurrencies } from "@app/store/referenceData";
import { RootState } from "@app/store/rootReducer";
import { BASE_TOOLTIP_ZINDEX } from "@app/util/map/consts";

import { DemographicRegionItem } from "../..";

import styles from "./DemographyTooltip.module.scss";

const OFFSET = { x: -100, y: 20 };

const messages = defineMessages({
  medianIncome: {
    id: "map.demography.tooltip.medianIncome",
    defaultMessage: "Median Income",
    description: "Median Income tooltip title",
  },
  population: {
    id: "map.demography.tooltip.population",
    defaultMessage: "Population",
    description: "Population tooltip title",
  },
});

interface Props {
  currencies: Currency[];
  demographicRegion?: DemographicRegionItem;
  position?: google.maps.LatLngLiteral;
}

const DemographyTooltip: React.FC<Props> = ({ currencies, demographicRegion, position }) => {
  const intl = useIntl();
  const { map } = useMap();

  if (!demographicRegion) {
    return null;
  }
  const { income, name, population } = demographicRegion;

  const isVisible = map && position && income !== undefined && population !== undefined;
  const currency = currencies?.find((currency) => currency.id === income?.currencyId);

  return isVisible ? (
    <OverlayView map={map} offset={OFFSET} position={position} zIndex={BASE_TOOLTIP_ZINDEX}>
      <div className={styles.container}>
        <div className={styles.text}>{name}</div>
        <div className={styles.infoArea}>
          <div className={styles.dataRow}>
            <span>{intl.formatMessage(messages.medianIncome)}</span>
            <span className={styles.data}>
              {income?.value != null
                ? intl.formatNumber(income?.value, {
                    currency: currency?.code,
                    minimumFractionDigits: 0,
                    style: "currency",
                  })
                : ""}
            </span>
          </div>
          <div className={styles.dataRow}>
            <span>{intl.formatMessage(messages.population)}</span>
            <span className={styles.data}>{intl.formatNumber(population)}</span>
          </div>
        </div>
      </div>
    </OverlayView>
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  currencies: getCurrencies(state),
});

export default connect(mapStateToProps)(DemographyTooltip);
